<div class="partner-card" *ngIf="isSuperAdmin()">
    <div class="partner-info">
        <span class="partner-label">Selected Partner</span>
        <span class="partner-value">{{ partnersService.currentPartner }}</span>
    </div>
    <mat-form-field class="partner-select">
        <mat-select [(ngModel)]="partnersService.currentPartner" (selectionChange)="changePartner($event)">
            <mat-option *ngFor="let option of dummyPartnersList" [value]="option">{{ option }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
